import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const useCart = () => {
    return useContext(CartContext);
};

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);

    const addToCart = async (product) => {
        try {
            setCart(prevCart => {
                const existingItem = prevCart.find(item => 
                    item.id === product.id && 
                    (!product.size || item.size === product.size)
                );

                if (existingItem) {
                    return prevCart.map(item =>
                        item.id === product.id && 
                        (!product.size || item.size === product.size)
                            ? { ...item, quantity: item.quantity + 1 }
                            : item
                    );
                }

                return [...prevCart, { ...product, quantity: 1 }];
            });
        } catch (error) {
            console.error('Error adding to cart:', error);
            throw error;
        }
    };

    const removeFromCart = (productId, size) => {
        setCart(prevCart => 
            prevCart.filter(item => 
                !(item.id === productId && (!size || item.size === size))
            )
        );
    };

    const updateQuantity = (productId, size, quantity) => {
        setCart(prevCart =>
            prevCart.map(item =>
                item.id === productId && (!size || item.size === size)
                    ? { ...item, quantity: Math.max(0, quantity) }
                    : item
            )
        );
    };

    const clearCart = () => {
        setCart([]);
    };

    return (
        <CartContext.Provider value={{
            cart,
            addToCart,
            removeFromCart,
            updateQuantity,
            clearCart
        }}>
            {children}
        </CartContext.Provider>
    );
}; 